module.exports = __webpack_public_path__ + "static/media/get-recommendations-desktop-en.7c52ae9e.png";